// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.facility-settings {
  padding-left: 178px;
  padding-top: 26px;
}
.facility-settings .facility-settings-action {
  display: flex;
  padding-top: 16px;
}
.facility-settings .facility-settings-item {
  display: flex;
  margin-bottom: 16px;
}
.facility-settings .facility-settings-item .form-item {
  margin-bottom: 16px;
}
.facility-settings .facility-settings-item .form-item .d-flex {
  width: 100%;
}
.facility-settings .facility-settings-item .form-item .form-item-mail {
  max-width: calc(100% - 34px);
  width: 100%;
}
.facility-settings .facility-settings-item .form-item .btn-icon {
  margin-left: 18px;
}
.facility-settings .facility-settings-item .form-item .btn-icon i:before {
  color: rgb(180, 35, 24);
}
.facility-settings .facility-settings-item .facility-settings-item-inputs {
  max-width: 380px;
  width: 100%;
  position: relative;
}
.facility-settings .facility-settings-item .facility-settings-item-inputs.facility-settings-item-inputs-checkbox {
  display: flex;
  align-items: center;
}
.facility-settings .facility-settings-item .facility-settings-item-inputs.facility-settings-item-inputs-checkbox .form-error {
  position: absolute;
  top: calc(100% - 24px);
  left: 0;
}
.facility-settings .facility-settings-item .facility-settings-item-inputs.facility-settings-item-inputs-checkbox .form-control-checkbox {
  margin-right: 76px;
}
.facility-settings .facility-settings-item .facility-settings-item-inputs.facility-settings-item-inputs-checkbox .form-control-checkbox:last-child {
  margin-right: 0;
}
.facility-settings .facility-settings-item .facility-settings-item-label {
  max-width: 471px;
  width: 100%;
  margin-right: 24px;
}
.facility-settings .facility-settings-item .facility-settings-item-label h3 {
  color: var(--Secondary-eading, #101828);
  font-family: Inter;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 24px;
  margin-bottom: 12px;
}
.facility-settings .facility-settings-item .facility-settings-item-label p {
  color: var(--Secondary-Text, #667085);
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 21px;
}

.settings-updated-alert {
  width: max-content;
  right: 150px;
}
.settings-updated-alert .Toastify__toast-body {
  font-size: 18px;
  color: var(--Secondary-eading, #101828);
  font-weight: 600;
}
.settings-updated-alert .Toastify__toast-body .Toastify__toast-icon {
  margin-right: 40px;
}
.settings-updated-alert .Toastify__progress-bar--success {
  background: #12b76a !important;
}
.settings-updated-alert .close-alert-btn {
  margin: 0 10px;
}
.settings-updated-alert .close-alert-btn:hover {
  opacity: 0.3;
}`, "",{"version":3,"sources":["webpack://./src/pages/facility/components/SettingsTab/styles.scss"],"names":[],"mappings":"AAAA;EACE,mBAAA;EACA,iBAAA;AACF;AACE;EACE,aAAA;EACA,iBAAA;AACJ;AAEE;EACE,aAAA;EACA,mBAAA;AAAJ;AAEI;EACE,mBAAA;AAAN;AAEM;EACE,WAAA;AAAR;AAGM;EACE,4BAAA;EACA,WAAA;AADR;AAIM;EACE,iBAAA;AAFR;AAIQ;EACE,uBAAA;AAFV;AAOI;EACE,gBAAA;EACA,WAAA;EACA,kBAAA;AALN;AAOM;EACE,aAAA;EACA,mBAAA;AALR;AAOQ;EACE,kBAAA;EACA,sBAAA;EACA,OAAA;AALV;AAQQ;EACE,kBAAA;AANV;AAQU;EACE,eAAA;AANZ;AAYI;EACE,gBAAA;EACA,WAAA;EACA,kBAAA;AAVN;AAYM;EACE,uCAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;AAVR;AAaM;EACE,qCAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AAXR;;AAiBA;EAcE,kBAAA;EACA,YAAA;AA3BF;AAaE;EACE,eAAA;EACA,uCAAA;EACA,gBAAA;AAXJ;AAaI;EACE,kBAAA;AAXN;AAcE;EACE,8BAAA;AAZJ;AAkBE;EAKE,cAAA;AApBJ;AAgBI;EACE,YAAA;AAdN","sourcesContent":[".facility-settings {\n  padding-left: 178px;\n  padding-top: 26px;\n\n  .facility-settings-action {\n    display: flex;\n    padding-top: 16px;\n  }\n\n  .facility-settings-item {\n    display: flex;\n    margin-bottom: 16px;\n\n    .form-item {\n      margin-bottom: 16px;\n\n      .d-flex {\n        width: 100%;\n      }\n\n      .form-item-mail {\n        max-width: calc(100% - 34px);\n        width: 100%;\n      }\n\n      .btn-icon {\n        margin-left: 18px;\n\n        i:before {\n          color: rgba(180, 35, 24, 1);\n        }\n      }\n    }\n\n    .facility-settings-item-inputs {\n      max-width: 380px;\n      width: 100%;\n      position: relative;\n\n      &.facility-settings-item-inputs-checkbox {\n        display: flex;\n        align-items: center;\n\n        .form-error {\n          position: absolute;\n          top: calc(100% - 24px);\n          left: 0;\n        }\n\n        .form-control-checkbox {\n          margin-right: 76px;\n\n          &:last-child {\n            margin-right: 0;\n          }\n        }\n      }\n    }\n\n    .facility-settings-item-label {\n      max-width: 471px;\n      width: 100%;\n      margin-right: 24px;\n\n      h3 {\n        color: var(--Secondary-eading, #101828);\n        font-family: Inter;\n        font-size: 16px;\n        font-style: normal;\n        font-weight: 600;\n        line-height: 24px;\n        margin-bottom: 12px;\n      }\n\n      p {\n        color: var(--Secondary-Text, #667085);\n        font-family: Inter;\n        font-size: 14px;\n        font-style: normal;\n        font-weight: 400;\n        line-height: 21px;\n      }\n    }\n  }\n}\n\n.settings-updated-alert {\n  .Toastify__toast-body {\n    font-size: 18px;\n    color: var(--Secondary-eading, #101828);\n    font-weight: 600;\n\n    .Toastify__toast-icon {\n      margin-right: 40px;\n    }\n  }\n  .Toastify__progress-bar--success {\n    background: #12b76a !important;\n  }\n\n  width: max-content;\n  right: 150px;\n\n  .close-alert-btn {\n    &:hover {\n      opacity: 0.3;\n    }\n\n    margin: 0 10px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
